var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullscreenOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "fullscreen_off_svg__\\uB808\\uC774\\uC5B4_1",
  x: 0,
  y: 0,
  fill: "currentColor",
  stroke: "currentColer",
  viewBox: "0 0 24 24"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fullscreen_off_svg__st0{fill:none}.fullscreen_off_svg__st1{stroke-linejoin:round}.fullscreen_off_svg__st1,.fullscreen_off_svg__st2{fill:none;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z",
  className: "fullscreen_off_svg__st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 1H1v6M23 7V1h-6M7 23H1v-6M23 17v6h-6",
  className: "fullscreen_off_svg__st1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m1 1 7 7M16 8l7-7M1 23l7-7M16 16l7 7",
  className: "fullscreen_off_svg__st2"
})));
export default SvgFullscreenOff;